import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";
import CheckIcon from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleEditCard/components/VehicleWizardIntro/scenes/CheckIcon";

import { USER_INTRO_SAMPLE } from "../consts";
import { UserSceneProps } from "../types";

/** Korak "Pregled": dovršeni dijelovi, kartica korisnika s ulogama i spremnost za prijavu. */
const UserSummaryScene: React.FC<UserSceneProps> = ({ user, isEdit }) => {
  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Pregled</div>
          <div className="text-sm font-bold text-slate-800 truncate">{user.fullName}</div>
          <div className="mt-3 space-y-2">
            {USER_INTRO_SAMPLE.summary.map((item) => (
              <div key={item} className="flex items-center gap-2 rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
                <CheckIcon />
                <span className="font-medium text-slate-700">{item}</span>
              </div>
            ))}
          </div>
          <div className="mt-3 rounded-md bg-slate-50 px-3 py-2 text-[0.7rem] text-slate-500 truncate">{user.email}</div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="flex items-center gap-2">
            <span className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-[0.65rem] font-bold text-blue-700 flex-shrink-0">
              {user.initials}
            </span>
            <div className="min-w-0">
              <div className="text-xs font-bold text-slate-800 truncate">{user.fullName}</div>
              <div className="text-[0.6rem] text-slate-400 truncate">{user.userName}</div>
            </div>
          </div>
          <div className="mt-3 flex flex-wrap gap-1.5">
            {user.roleNames.slice(0, 3).map((role) => (
              <span key={role} className="px-2 py-0.5 rounded-full text-[0.6rem] font-semibold bg-blue-50 text-blue-700">
                {role}
              </span>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title={isEdit ? "Promjene odmah vrijede" : "Spreman za prijavu"}
          subtitle={isEdit ? "Nakon spremanja" : "Odmah nakon spremanja"}
          iconClassName="bg-emerald-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#047857" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M20 6L9 17l-5-5" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(UserSummaryScene);
